import React from "react";
import { IconT } from "types/utils";
import { theme } from "styles/themes";

const ChangeOrderRejectedIcon = ({ fill = theme.colors.white, height = 22, width = 19 }: IconT) => (
  <svg width={width} height={height} viewBox="0 0 19 22" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M17 8.5V5.8C17 4.11984 17 3.27976 16.673 2.63803C16.3854 2.07354 15.9265 1.6146 15.362 1.32698C14.7202 1 13.8802 1 12.2 1H5.8C4.11984 1 3.27976 1 2.63803 1.32698C2.07354 1.6146 1.6146 2.07354 1.32698 2.63803C1 3.27976 1 4.11984 1 5.8V16.2C1 17.8802 1 18.7202 1.32698 19.362C1.6146 19.9265 2.07354 20.3854 2.63803 20.673C3.27976 21 4.11984 21 5.8 21H11M11 10H5M7 14H5M13 6H5M13.5 14.0022C13.6762 13.5014 14.024 13.079 14.4817 12.81C14.9395 12.5409 15.4777 12.4426 16.001 12.5324C16.5243 12.6221 16.999 12.8942 17.3409 13.3004C17.6829 13.7066 17.87 14.2207 17.8692 14.7517C17.8692 16.2506 15.6209 17 15.6209 17M15.6499 20H15.6599"
      stroke={fill}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default ChangeOrderRejectedIcon;
